import { PilotThemeConfigSchema, type PilotThemeConfig } from "../theme-config.js";
import pilotTerminalJson from "./pilot-terminal.json";
import pilotExampleJson from "./pilot-example.json";

// `pilot-terminal` is the canonical aesthetic — it leads the array so it
// is the fallback when no defaultTheme is configured. `pilot-example`
// exists to prove the multi-theme cascade works end-to-end and to give
// designers a contrasting palette to inspect side-by-side; it is not
// promoted to any consumer.
export const pilotTerminal: PilotThemeConfig = PilotThemeConfigSchema.parse(pilotTerminalJson);
export const pilotExample: PilotThemeConfig = PilotThemeConfigSchema.parse(pilotExampleJson);

export const themes: PilotThemeConfig[] = [pilotTerminal, pilotExample];
